import React from 'react';
import { Helmet } from 'react-helmet';
import { Container } from '@material-ui/core';
import { useEffect } from 'react';
import { MY_EIR_CONST } from '../../../../components/myeirconstant/myEirConstant';
import { useWindowDimension } from '../../../../hooks/windowDimensions';

/**
 * @name SweeprContainer - Sweepr Application Component
 * @param {*}props - URL query paramters
 * @returns {JSX.Element} - Returns Sweepr Application in iframe
 */
const SweeprContainer = props => {
    const [width] = useWindowDimension();
    /**
     * @function sweeprCallback
     * @description  Callback function when sweepr troubleshooting is completed
     */
    window.sweeprCallback = () => {
        window.location.href = `${MY_EIR_CONST.url.REDIRECT_URL}help`;
    };

    useEffect(() => {
        const recaptchaBadge = document?.querySelector('.grecaptcha-badge');
        if (recaptchaBadge) {
            recaptchaBadge.style.display = 'none';
        }
        try {
            /**
             * @function reInitializeSweeprWidget
             * @description To re-initialize sweepr widget when OTC changes
             */
            const reInitializeSweeprWidget = () => {
                window.sweeprWidgetBuilt = false;
                window.SweeprWidget = new SweeprWidget();
            };
            reInitializeSweeprWidget();
        } catch (error) {
            console.error('Error loading sweepr widget:', error);
        }
    }, [props.OTC]); // Re-run this effect whenever OTC changes

    return (
        <Container>
            <Helmet>
                <link
                    rel='stylesheet'
                    type='text/css'
                    href={`${MY_EIR_CONST.url.SWEEPR_WIDGET_CSS}`}
                />
                <script src={`${MY_EIR_CONST.url.SWEEPR_WIDGET_JS}`} async />
            </Helmet>
            {props?.OTC && (
                <div
                    data-widget-type='modal'
                    id='sweepr-widget'
                    data-interaction-end-callback='sweeprCallback'
                    data-widget-url={`${MY_EIR_CONST.url.SWEEPR_APPLICATION}`}
                    data-support-resources-url={`${MY_EIR_CONST.url.SUPPORT_REDIRECT_URL}`}
                    data-widget-visible='true'
                    data-widget-display-home='true'
                    data-widget-static-size='true'
                    class='sweepr-widget type-modal'
                    data-widget-otc={props?.OTC}
                    data-sweepr-utterance={props?.Utterance}
                    style={{ display: 'flex', zIndex: 9999, paddingBottom: width < 600 && '4rem' }}
                ></div>
            )}
        </Container>
    );
};

SweeprContainer.displayName = 'SweeprContainer';
export default SweeprContainer;
